import { Injectable } from '@angular/core';
import { Network } from '@ionic-native/network';
import { Platform } from 'ionic-angular';
 
declare var Connection;
 
@Injectable()
export class ConnectivityService {
 
  onDevice: boolean;
 
  constructor(public platform: Platform){
    this.onDevice = this.platform.is('cordova');
  }
 
  isOnline(): boolean {
    
    if(this.onDevice && navigator['connection']){
      return navigator['connection'] !== Connection.NONE;
    } else {
      return navigator.onLine; 
    }
  }
 
  isOffline(): boolean {
    if(this.onDevice && navigator['connection']){
      return navigator['connection'] === Connection.NONE;
    } else {
      return !navigator.onLine;   
    }
  }
}



// WEBPACK FOOTER //
// ./src/providers/connectivity-service.ts